import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField, CircularProgress, Chip } from '@material-ui/core';
import parcelsApi from '../../api/parcelsApi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import throttle from 'lodash/throttle';

const FormParcelAutocompleteField = ({ label, meta: { touched, error }, input, disabled, budgetId }) => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const fetch = useMemo(
    () =>
      throttle((value, callback) => {
        parcelsApi.loadParcels(budgetId, value)
          .then(values => callback(values.data.map(value => ({ value, label: value }))))
          .catch(() => callback([]));
      }, 200),
    [],
  );

  const handleChange = event => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    let active = true;
    if (!inputValue || inputValue.length < 3) {
      return undefined;
    }

    setLoading(true);
    fetch(inputValue, results => {
      if (active) {
        setOptions(results);
      }
      setLoading(false);
    });

    return () => {
      active = false;
    };
  }, [inputValue, fetch]);

  return (
    <div>
      <Autocomplete
        style={{ width: 220 }}
        options={options}
        loading={loading}
        filterSelectedOptions
        noOptionsText="Nie znaleziono wpisów"
        loadingText="Ładowanie wpisów"
        getOptionLabel={option => option.label}
        onChange={(_, value) => {
          input.onChange(value ? value.map(v => v.value).join(';') : null);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => <Chip key={index} label={option.label} {...getTagProps({ index })} size="small" />)
        }
        renderInput={params => (<TextField
          {...params}
          onChange={handleChange}
          placeholder={input.value ? undefined : "Wybierz numer działki"}
          label={label}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }} />)}
        disabled={disabled}
        multiple
      />
      {error && touched ? <Typography variant="caption" color="error">{error}</Typography> : null}
    </div >);
};


FormParcelAutocompleteField.propTypes = {
  classes: PropTypes.object.isRequired,
  budgetId: PropTypes.string.isRequired,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default FormParcelAutocompleteField;



// WEBPACK FOOTER //
// ./src/components/form/FormParcelAutocompleteField.js